import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { TransactionEventType } from '../features/billing/api/types';
import i18n from '../i18n';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format amount as integer string with proper minus sign (no cents)
 */
export function formatAmount(amount: string): string {
  const num = Number(amount);
  if (Number.isNaN(num)) return '0';
  const rounded = Math.round(num);
  const str = String(rounded);
  // Replace ascii hyphen-minus with mathematical minus
  return str.replace('-', '−');
}

/**
 * Get localized transaction type display name
 */
export function getTransactionTypeDisplayName(
  type: TransactionEventType
): string {
  switch (type) {
    case TransactionEventType.Deposit:
      return i18n.t('billing.transactions.type.deposit');
    case TransactionEventType.EventCharge:
      return i18n.t('billing.transactions.type.eventCharge');
    case TransactionEventType.SelfCharge:
      return i18n.t('billing.transactions.type.selfCharge');
    default:
      return 'Unknown';
  }
}
